export var PrintingIntentType;
(function (PrintingIntentType) {
    PrintingIntentType["TASK_LABEL"] = "task-label";
    PrintingIntentType["TOUR_LABEL"] = "tour-label";
    PrintingIntentType["TEST_PRINT"] = "test-print";
})(PrintingIntentType || (PrintingIntentType = {}));
